// extracted by mini-css-extract-plugin
export default {"comment":"Comment_comment__dqW15"};